import { getForms } from "../../../services/forms.services";
import { useEffect, useState } from "react";
import { IForms } from "../../../types/forms";
import ReactPagination from "../../Common/ReactPagination";
import Loading from "../../Common/LoadingScreen";
import { useNavigate } from "react-router-dom";
import Moment from "moment";
import deleteDataByID from "../../../services/delete.services";

import Modal from "react-modal";
import { jwtDecode } from "jwt-decode";
import downloadAsFiles from "../../../services/download.services";

export const NRFList = (): JSX.Element => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [NRFList, setNRFList] = useState<any>();
  const [limit, setLimit] = useState<number>(15);
  const [offset, setOffSet] = useState<number>(0);
  const [search, setSearch] = useState<string>("");
  const [buttonDisable, setButtonDisable] = useState<boolean>(false);

  const [selectedData, setSelectedData] = useState<any>([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState<boolean>(false);

  const [deleteDataByIDModal, setDeleteDataByIDModal] = useState(false);
  const [dataID, setDataID] = useState();
  const [firstName, setFirstName] = useState();
  const [lastName, setLastName] = useState();
  const handleModal = () => setDeleteDataByIDModal(!deleteDataByIDModal);

  const deleteValue = (id: any, firstName: any, lastName: any) => {
    setFirstName(firstName);
    setLastName(lastName);
    setDataID(id);
  };

  const tokenInfo: any = jwtDecode(
    localStorage.getItem("access_token") as string
  );

  const handleDelete = async (id: any) => {
    try {
      deleteDataByID(id);
      handleModal();
      getNRFList();
    } catch (e: any) {
      if (!e.statusCode) {
        localStorage.removeItem("access_token");
        navigate("/");
      }
    }
  };

  useEffect(() => {
    getNRFList();
  }, [offset, limit, search]);

  const getNRFList = async () => {
    const getFormsArgs = {
      formTypeId: 8,
      limit: limit,
      offset: offset,
      name: search,
    };
    try {
      const allNRFList = await getForms(getFormsArgs);
      setNRFList(allNRFList.data);
      setIsLoading(false);
    } catch (e: any) {
      if (!e.statusCode) {
        localStorage.removeItem("access_token");
        navigate("/");
      }
    }
  };

  useEffect(() => {
    // console.log('Syllabus: ', Syllabus?.data);

    const includes = NRFList?.data.every((nrf: any) => {
      return selectedData?.some((selected: any) => selected.id === nrf.id);
    });

    includes ? setIsSelectAllChecked(true) : setIsSelectAllChecked(false);
  }, [NRFList?.data]);

  const handleInput = (event: any) => {
    setSearch(event.target.value);
  };

  const handleDownload = async () => {
    setButtonDisable(true);
    const fileData = await downloadAsFiles("formTypeId=8");
    // const blob = new Blob([fileData.data], { type: 'text/csv;charset=utf-8;' });

    const selectedFileData = await downloadAsFiles(
      `formTypeId=8${selectedData
        .map((item: any) => `&selectedId=${item.id}`)
        .join("")}`
    );

    let blob: any;
    if (selectedData) {
      blob = new Blob([selectedFileData.data], {
        type: "text/csv;charset=utf-8;",
      });
    } else {
      blob = new Blob([fileData.data], { type: "text/csv;charset=utf-8;" });
    }

    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "NRFList.csv");
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
    setButtonDisable(false);

    getNRFList();
  };

  const handleChange = (e: any) => {
    const { id, checked } = e.target;

    let filteredCheckedData: any = [];
    let allCheckedData: any = [];

    if (id === "selectAll") {
      if (
        checked &&
        !NRFList?.data.every((nrf: any) => {
          return selectedData?.some((selected: any) => selected.id === nrf.id);
        })
      ) {
        allCheckedData = [
          ...selectedData,
          ...NRFList?.data.map((nrf: any) => ({
            ...nrf,
            // checked: true,
          })),
        ];
      } else if (
        !checked &&
        NRFList?.data.every((nrf: any) => {
          return selectedData?.some((selected: any) => selected.id === nrf.id);
        })
      ) {
        allCheckedData = selectedData?.filter(
          (data: any) =>
            !NRFList?.data.some(
              (nrf: any) => nrf.id === data.id && nrf.name === data.name
            )
        );
      }

      if (allCheckedData.length > 0) {
        filteredCheckedData = allCheckedData?.filter(
          (dataItem: any, index: any, self: any) =>
            index ===
            self.findIndex(
              (i: any) => i.id === dataItem.id && i.name === dataItem.name
            )
        );
        setSelectedData(filteredCheckedData);
      } else {
        setSelectedData(allCheckedData);
      }
      setIsSelectAllChecked(checked);
    } else {
      const updatedSelectedData = checked
        ? [
            ...selectedData,
            NRFList?.data.find((nrf: any) => nrf.id === Number(id)),
          ]
        : selectedData?.filter((contact: any) => contact.id !== Number(id));

      // console.log('Updated Selected Data', updatedSelectedData);

      setSelectedData(updatedSelectedData);

      NRFList?.data.every((nrf: any) => {
        return updatedSelectedData?.some(
          (element: any) => element.id === nrf.id
        );
      })
        ? setIsSelectAllChecked(true)
        : setIsSelectAllChecked(false);
    }
  };
  return (
    <>
      <section className="main-container">
        <div className="top-section row align-items-center">
          <div className="col-md-7 col-xl-8">
            <div className="xlarge-text-size">Event</div>
          </div>
          <div className="col-md-3 col-xl-2 text-right">
            <input
              value={search}
              onChange={handleInput}
              placeholder="Search by email"
            />
          </div>
          <div className="col-md-2 text-right">
            <button
              type="button"
              className="btn"
              onClick={handleDownload}
              disabled={buttonDisable}
            >
              Download{" "}
              {selectedData?.length === 0 ? "all" : selectedData?.length}
            </button>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="table-responsive">
              {isLoading && <Loading />}
              <table className="table">
                <thead>
                  <tr>
                    <th className="xs">
                      <input
                        type="checkbox"
                        id="selectAll"
                        onChange={handleChange}
                        checked={isSelectAllChecked}
                      />
                    </th>
                    <th className="xs">S.No.</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Email Status</th>
                    <th>Contact Number</th>
                    <th className="">Event Name</th>
                    <th className="">Country</th>
                    <th className="md">Page url</th>
                    <th className="lg">Message</th>
                    <th className="sm">Source</th>
                    <th className="sm">Medium</th>
                    <th className="sm">Campaign</th>
                    <th className="sm">Content</th>
                    <th>Submitted on</th>
                    {tokenInfo.permissions[0] === "Delete" ? (
                      <th className="xs">Action</th>
                    ) : (
                      ""
                    )}
                  </tr>
                </thead>
                <tbody>
                  {NRFList?.data === ""
                    ? "Empty data"
                    : NRFList?.data.map((NRFList: IForms, index: any) => {
                        return (
                          <tr key={NRFList.id}>
                            <td>
                              <input
                                type="checkbox"
                                id={JSON.stringify(NRFList.id)}
                                checked={selectedData?.some(
                                  (item: any) => item.id === NRFList.id
                                )}
                                onChange={handleChange}
                              />
                            </td>
                            <td>
                              <span>{index + 1 + offset}</span>
                            </td>
                            <td>
                              <span>
                                {NRFList.fullName === "null"
                                  ? NRFList.fullName
                                  : `${NRFList.firstName} ${NRFList.lastName}`}
                              </span>
                            </td>
                            <td>
                              <span>{NRFList.email}</span>
                            </td>
                            <td>
                              <span
                                className={`badge ${
                                  NRFList?.emailVerificationStatus?.toLowerCase() ??
                                  ""
                                }`}
                              >
                                {NRFList?.emailVerificationStatus?.toLowerCase() ??
                                  "-"}
                              </span>
                            </td>
                            <td>
                              <span>{NRFList.contactNumber}</span>
                            </td>
                            <td className="">
                              <span>{NRFList.eventName}</span>
                            </td>
                            <td className="">
                              <span>{NRFList.country}</span>
                            </td>
                            <td className="md">
                              <span>{NRFList.pageUrl}</span>
                            </td>
                            <td className="lg">
                              <span>{NRFList.message}</span>
                            </td>
                            <td className="sm">
                              <span>{NRFList.utmSource}</span>
                            </td>
                            <td className="sm">
                              <span>{NRFList.utmMedium}</span>
                            </td>
                            <td className="sm">
                              <span>{NRFList.utmCampaign}</span>
                            </td>
                            <td className="sm">
                              <span>{NRFList.utmContent}</span>
                            </td>
                            <td className="sm">
                              <span className="">
                                {Moment(NRFList.createdAt).format(
                                  "ddd, MMM Do YYYY, h:mm:ss a"
                                )}
                              </span>
                            </td>
                            {tokenInfo.permissions[0] === "Delete" ? (
                              <>
                                <td className="xs">
                                  <button
                                    className="btn-danger btn"
                                    type="button"
                                    onClick={() => {
                                      handleModal();
                                      deleteValue(
                                        NRFList.id,
                                        NRFList.lastName,
                                        NRFList.firstName
                                      );
                                    }}
                                  >
                                    Delete
                                  </button>
                                </td>{" "}
                              </>
                            ) : (
                              ""
                            )}
                          </tr>
                        );
                      })}
                </tbody>
              </table>
            </div>
            <ReactPagination
              totalData={NRFList}
              setLimit={setLimit}
              setOffSet={setOffSet}
              limit={limit}
            />
          </div>
        </div>
      </section>

      <Modal
        isOpen={deleteDataByIDModal}
        onRequestClose={handleModal}
        contentLabel="delete-data"
      >
        <div className="head">
          <h4>Remove data</h4>
        </div>
        <div className="m-body">
          <div>
            Are you sure you want to remove this{" "}
            <b>
              {firstName} {lastName}
            </b>{" "}
            data
          </div>
        </div>
        <div className="m-footer">
          <button className="btn btn-link" onClick={handleModal}>
            Close
          </button>{" "}
          {"  "}
          <button
            className="btn btn-danger"
            onClick={() => handleDelete(dataID)}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};
